export default __webpack_public_path__ + "static/media/wisemonkeys-userdata.4f6ebe6e.xlsx";